import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { AppBar, Box, Stack, Toolbar, Badge } from "@mui/material";
import { connect } from "react-redux";
import { RiDashboardLine } from "react-icons/ri";
import { TbHeadset, TbReportSearch } from "react-icons/tb";
import { IoHeadsetOutline, IoTimerOutline } from "react-icons/io5";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import {
  MdDashboardCustomize,
  MdOutlineDashboardCustomize,
  MdOutlinePhoneMissed,
} from "react-icons/md";
import { TbReportAnalytics } from "react-icons/tb";
import { SiPowerbi } from "react-icons/si";
import { MdOutlineCampaign } from "react-icons/md";
import { PiChats } from "react-icons/pi";
import {
  LuUsers,
  LuFolderSearch,
  LuBarChart3,
  LuContact,
} from "react-icons/lu";
import { MdOutlineHomeRepairService } from "react-icons/md";
import { IoIosContacts } from "react-icons/io";
import { TbUsersGroup } from "react-icons/tb";
import {
  clearnotify,
  setsidebarVal,
  setExternalChatData,
  setValue,
} from "../../Redux/Actions/actions";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { ChartLineUp, PhoneSlash } from "@phosphor-icons/react";
import { FaWhatsapp } from "react-icons/fa6";

const mapStateToProps = (state) => {
  return {
    notification: state.notification.notification,
    sidebarVal: state.contactListData.sidebarVal,
  };
};
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "0 2px",
    right: "1px",
    top: "2px",
    fontSize: "8px",
    height: "13px",
    minWidth: "13px",
  },
}));

const StyledBox = styled(Box)(({ theme }) => ({
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "9px",
  transition: "transform 0.3s ease",
  "&:hover": {
    background: "rgba(255, 255, 255, 0.5)",
    WebkitBackdropFilter: "blur(24px)",
    backdropFilter: "blur(24px)",
  },
  "&:active": {
    background: "rgba(255, 255, 255, 0.5)",
    WebkitBackdropFilter: "blur(24px)",
    backdropFilter: "blur(24px)",
    border: "1px solid white",
    transform: "scale(0.69)",
  },
}));

const Sidebar = (props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  let agentRole = JSON.parse(localStorage.getItem("tokenAgent")) || {};
  let permission = JSON.parse(localStorage.getItem("permission")) || [];
  const intervalIdRefMissedCall = useRef(null);

  const [AbandonedCount, setAbandonedCount] = useState(0);
  const [AbandonedCountSupervisoragent, setAbandonedCountSupervisoragent] =
    useState(0);
  const [campaignCount, setcampaignCount] = useState(0);
  const [queueCount, setqueueCount] = useState(0);
  const [totalcalls, settotalcalls] = useState(0);
  const [totalAbandonCalls, setTotalAbandonCalls] = useState(0);
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  let loggedInAgent = JSON.parse(localStorage.getItem("tokenAgent"));

  const missedCall = async () => {
    JSON.parse(localStorage.getItem("permission")).map(async (module) => {
      if (module.moduleName === "SIDEBAR") {
        const crmScreen = module.screen.find(
          (item) =>
            (item.screenId === "MISSEDCALL" && item.read && item.write) ||
            (item.screenId === "CAMPAIGN" && item.read && item.write) ||
            (item.screenId === "QUEUED_INTERACTION" && item.read && item.write)
        );
        if (crmScreen) {
          await axios
            .post(
              BaseUrl + "/contact/missedcallcount",
              {
                agent_id: agentRole.agent_id,
                role: agentRole.role == "Supervisor" ? "Supervisor" : "agent",
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              if (res.data.status) {
                if (agentRole.role == "Supervisor") {
                  setAbandonedCountSupervisoragent(res.data.count);
                  setqueueCount(res.data.queuecount);
                  setcampaignCount(res.data.campaigncount);
                } else {
                  setAbandonedCount(res.data.count);
                  setqueueCount(res.data.queuecount);
                  setcampaignCount(res.data.campaigncount);
                }
              } else {
                setAbandonedCount(0);
                setqueueCount(0);
                setcampaignCount(0);
                setAbandonedCountSupervisoragent(0);
              }
            })
            .catch((err) => {
              console.log("");
            });
        }
      }
    });
  };

  const AgentListCampaign = async () => {
    let data = {
      from_date: fromdate,
      to_date: todate,
      agent_id: loggedInAgent.agent_id,
      offset: 1,
      limit: 10,
    };
    JSON.parse(localStorage.getItem("permission")).map(async (module) => {
      if (module.moduleName === "SIDEBAR") {
        const crmScreen = module.screen.find(
          (item) => item.screenId === "CAMPAIGN" && item.read && item.write
        );
        if (crmScreen) {
          await axios
            .post(BaseUrl + "/contact/listcampaign", data, {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
                tenantId: localStorage.getItem("TenantId"),
              },
            })
            .then((res) => {
              if (res.data.status == true) {
                settotalcalls(res.data.count);
              } else {
                settotalcalls(0);
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        }
      }
    });
  };

  const MissedCallsAPi = (value) => {
    JSON.parse(localStorage.getItem("permission")).map(async (module) => {
      if (module.moduleName === "SIDEBAR") {
        const crmScreen = module.screen.find(
          (item) => item.screenId === "MISSEDCALL" && item.read && item.write
        );
        if (crmScreen) {
          axios
            .post(
              BaseUrl + "/contact/listCampaignDetails",
              {
                from_date: defaultValue,
                to_date: defaultValue,
                agent_id: loggedInAgent.agent_id,
                limit: 10,
                offset: 1,
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              }
            )
            .then((res) => {
              setspinner(true);
              if (res.data.status) {
                setTotalAbandonCalls(res.data.count);
              } else {
                setTotalAbandonCalls(0);
              }
            })
            .catch((err) => {
              setTimeout(() => {}, 1500);
            });
        }
      }
    });
  };

  function startIntervalAbandoned() {
    if (!intervalIdRefMissedCall.current) {
      intervalIdRefMissedCall.current = setInterval(() => {
        missedCall();
        AgentListCampaign();
        MissedCallsAPi();
      }, 60000);
    }
  }
  function stopIntervalAbandoned() {
    if (intervalIdRefMissedCall.current) {
      clearInterval(intervalIdRefMissedCall.current);
      intervalIdRefMissedCall.current = null;
    }
  }

  useEffect(() => {
    startIntervalAbandoned();
    missedCall();
    AgentListCampaign();
    MissedCallsAPi();
    return () => {
      stopIntervalAbandoned();
    };
  }, []);

  return (
    <AppBar
      position="static"
      sx={{
        background: "linear-gradient(0deg, #175ab6 49%, #194d8f 100%)",
        height: "100%",
        width: "100%",
        padding: 0,
        borderRadius: "7px",
      }}
    >
      <Toolbar
        sx={{
          "@media screen and (min-width: 600px)": {
            minHeight: "32rem",
            padding: 0,
          },
          "@media screen and (min-width: 0px)": {
            minHeight: "32rem",
            padding: 0,
          },
        }}
      >
        <Stack alignItems={"center"} sx={{ height: "100%", width: "100%" }}>
          <Box
            className="my-2 h-100"
            sx={{
              overflowY: "scroll",
            }}
          >
            <Stack spacing={1}>
              {agentRole.role === "Agent" ? (
                <>
                  {/* Dashboard */}
                  {permission.map((module, index) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "DASHBOARD" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Dashboard"
                            placement="right"
                            arrow
                            key={index}
                          >
                            <Link
                              to={`/main/Dashboard`}
                              onClick={() => {
                                props.setsidebarVal("Dashboard");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal === "Dashboard"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <RiDashboardLine color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <React.Fragment key={index}></React.Fragment>;
                      }
                    }

                    return <React.Fragment key={index}></React.Fragment>;
                  })}
                  {/* Chat */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "INTERACTION" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Interaction" placement="right" arrow>
                            <Link
                              to={`/main/Chat`}
                              onClick={() => {
                                props.setsidebarVal("Chat");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Chat" ? "#347EDD" : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={props.notification.length}
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <PiChats color="white" size={17} />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Session Report */}
                  {permission.map((module) => {
                    if (
                      module.moduleName === "REPORT" &&
                      agentRole.role == "Agent"
                    ) {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SESSION_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Session Report"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/SessionReports`}
                              onClick={() => {
                                props.setsidebarVal("SessionReports");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "SessionReports"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbReportAnalytics color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Multimedia Search */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "MULTIMEDIA_SEARCH" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Multimedia Search"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/multimediasearch`}
                              onClick={() => {
                                props.setsidebarVal("multimediasearch");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "multimediasearch"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuFolderSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Web Statistic */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "WEB_STATISTICS" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Web Statistic"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/statistic`}
                              onClick={() => {
                                props.setsidebarVal("statistic");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "statistic"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuBarChart3 color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* CMS Contacts */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CUSTOMER_CONTACTS" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="CMS Contacts" placement="right" arrow>
                            <Link
                              to={`/main/Contacts`}
                              onClick={() => {
                                props.setsidebarVal("Contacts");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Contacts"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuFolderSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Campaign */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CAMPAIGN" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Camaign" placement="right" arrow>
                            <Link
                              to={`/main/Campaign`}
                              onClick={() => {
                                props.setsidebarVal("Campaign");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Campaign"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={totalcalls ? totalcalls : 0}
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <MdOutlineCampaign color="white" size={17} />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Missed Call */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CALLBACK" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Missed Call" placement="right" arrow>
                            <Link
                              to={`/main/MissedCalls`}
                              onClick={() => {
                                props.setsidebarVal("MissedCalls");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "MissedCalls"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={
                                    AbandonedCount ? AbandonedCount : 0
                                  }
                                  max={99}
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <MdOutlinePhoneMissed
                                    color="white"
                                    size={17}
                                  />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* powerBi v1 */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "POWERBI" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="powerBi v1" placement="right" arrow>
                            <Link
                              to={`/main/powerBi`}
                              onClick={() => {
                                props.setsidebarVal("powerBi");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "powerBi"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <SiPowerbi color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Agent Contact */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SALES_SERVICE_GALADHARI" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Contact" placement="right" arrow>
                            <Link
                              to={`/main/Agent-Contact`}
                              onClick={() => {
                                props.setsidebarVal("Agent-Contact");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Agent-Contact"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <IoIosContacts color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* salesreport GALADHARI*/}
                  {permission.map((module) => {
                    if (module.moduleName === "REPORT") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SALES_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Sales Reports"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/salesreport`}
                              onClick={() => {
                                props.setsidebarVal("salesreport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "salesreport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <ChartLineUp color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* servicereport GALADHARI*/}
                  {permission.map((module) => {
                    if (module.moduleName === "REPORT") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SERVICE_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Service Reports"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/servicereport`}
                              onClick={() => {
                                props.setsidebarVal("servicereport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "servicereport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <MdOutlineHomeRepairService
                                  color="white"
                                  size={17}
                                />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* customerdetails AGMC*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CUSTOMERDETAILS_AGMC" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Customer Details"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/customerdetails`}
                              onClick={() => {
                                props.setsidebarVal("customerdetails");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "customerdetails"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbUsersGroup color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* makecall */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Abandoned Calls"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/makecall`}
                              onClick={() => {
                                props.setsidebarVal("makecall");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "makecall"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <HiOutlinePhoneMissedCall
                                  color="white"
                                  size={17}
                                />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* WhatsappoutboundReport */}
                  {permission.map((module) => {
                    if (module.moduleName === "REPORT" && agentRole.role == "Agent") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "WHATSAPP_OUTBOUND_REPORT" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Whatsapp Outbound Report"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/WhatsappoutboundReport`}
                              onClick={() => {
                                props.setsidebarVal("WhatsappoutboundReport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "WhatsappoutboundReport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <FaWhatsapp color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CALL_RECORDING" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Call Queries" placement="right" arrow>
                            <Link
                              to={`/main/callqueries`}
                              onClick={() => {
                                props.setsidebarVal("Callqueries");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Callqueries"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbHeadset color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "UC_RECORDING" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="CallRecording"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/UCCallRecording`}
                              onClick={() => {
                                props.setsidebarVal("UCCallRecording");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "UCCallRecording"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <IoHeadsetOutline color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.some(
                        (item) =>
                          item.screenId === "REALTIMEDASHBOARD" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Realtime Dashboard"
                            placement="right"
                            arrow
                            key={"RealtimeDashboard"}
                          >
                            <Link
                              to={`/main/RealTimeDashboard`}
                              onClick={() => {
                                props.setsidebarVal("RealTimeDashboard");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "RealTimeDashboard"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <IoTimerOutline color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return null;
                      }
                    }
                    return null;
                  })}

                  {/* {permission.map((module) => {
                    if (module.moduleName === "REPORT") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "TOTAL_DETAIL_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Total Detail Report"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/totaldetailsreport`}
                              onClick={() => {
                                props.setsidebarVal("Totaldetailreport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Totaldetailreport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbReportSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })} */}

                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SUPERADMIN_DASHBOARD" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Supervisor Dashboard"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/supervisorDashboard`}
                              onClick={() => {
                                props.setsidebarVal("supervisordashboard");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "supervisordashboard"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <MdOutlineDashboardCustomize
                                  color="white"
                                  size={17}
                                />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                </>
              ) : (
                <>
                  {/* Dashboard supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "DASHBOARD" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Dashboard" placement="right" arrow>
                            <Link
                              to={`/main/Dashboard`}
                              onClick={() => {
                                props.setsidebarVal("Dashboard");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Dashboard"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <RiDashboardLine color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Chat supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "INTERACTION" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Interaction" placement="right" arrow>
                            <Link
                              to={`/main/Chat`}
                              onClick={() => {
                                props.setsidebarVal("Chat");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Chat" ? "#347EDD" : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={props.notification.length}
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <PiChats color="white" size={17} />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}

                  {/* Multimedia Search supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "MULTIMEDIA_SEARCH" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Multimedia Search"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/multimediasearch`}
                              onClick={() => {
                                props.setsidebarVal("multimediasearch");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "multimediasearch"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuFolderSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Web Statistic supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "WEB_STATISTICS" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Web Statistic"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/statistic`}
                              onClick={() => {
                                props.setsidebarVal("statistic");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "statistic"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuBarChart3 color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}


                  {/* RealTime Dashboard */}

                  {permission.map((module) => {
                if (module.moduleName === "SIDEBAR") {
                  const value = module.screen.some(
                    (item) =>
                      item.screenId === "REALTIMEDASHBOARD" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tooltip
                        title="Realtime Dashboard"
                        placement="right"
                        arrow
                        key={"RealtimeDashboard"}
                      >
                        <Link
                          to={`/main/RealTimeDashboard`}
                          onClick={() => {
                            props.setsidebarVal("RealTimeDashboard");
                            props.setValue(0);
                          }}
                        >
                          <StyledBox
                            sx={{
                              background:
                                props.sidebarVal == "RealTimeDashboard"
                                  ? "#347EDD"
                                  : "",
                            }}
                          >
                            <IoTimerOutline color="white" size={17} />
                          </StyledBox>
                        </Link>
                      </Tooltip>
                    );
                  } else {
                    return null;
                  }
                }
                return null;
              })}


                  {/* CMS Contacts supervisor */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CUSTOMER_CONTACTS" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="CMS Contacts" placement="right" arrow>
                            <Link
                              to={`/main/Contacts`}
                              onClick={() => {
                                props.setsidebarVal("Contacts");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Contacts"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <LuFolderSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Campaign supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CAMPAIGN" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Campaign" placement="right" arrow>
                            <Link
                              to={`/main/Campaign`}
                              onClick={() => {
                                props.setsidebarVal("Campaign");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Campaign"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={
                                    campaignCount ? campaignCount : 0
                                  }
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <MdOutlineCampaign color="white" size={17} />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Missed Call supervisor*/}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CALLBACK" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Missed Call"
                            placement="right"
                            arrow
                            key={"MissedCalls"}
                          >
                            <Link
                              to={`/main/MissedCalls`}
                              onClick={() => {
                                props.setsidebarVal("MissedCalls");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "MissedCalls"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={
                                    AbandonedCountSupervisoragent
                                      ? AbandonedCountSupervisoragent
                                      : 0
                                  }
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <MdOutlinePhoneMissed
                                    color="white"
                                    size={17}
                                  />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}

                  {/*Abandont supervisoragent supervisor*/}
                  {agentRole.role == "Supervisor" &&
                    agentRole.supervisoragent &&
                    permission.map((module) => {
                      if (module.moduleName === "SIDEBAR") {
                        const value = module.screen.find(
                          (item) =>
                            item.screenId === "CALLBACK" &&
                            item.read &&
                            item.write
                        );

                        if (value) {
                          return (
                            <Tooltip
                              title="Abandoned Call"
                              placement="right"
                              arrow
                              key={"Abandoned"}
                            >
                              <Link
                                to={`/main/makecall`}
                                onClick={() => {
                                  props.setsidebarVal("makecall");
                                  props.setValue(0);
                                }}
                              >
                                <StyledBox
                                  sx={{
                                    background:
                                      props.sidebarVal == "makecall"
                                        ? "#347EDD"
                                        : "",
                                  }}
                                >
                                  <StyledBadge
                                    badgeContent={
                                      totalAbandonCalls ? totalAbandonCalls : 0
                                    }
                                    sx={{
                                      ".MuiBadge-badge": {
                                        background: "#DB3240",
                                        color: "white",
                                      },
                                    }}
                                  >
                                    <PhoneSlash color="white" size={17} />
                                  </StyledBadge>
                                </StyledBox>
                              </Link>
                            </Tooltip>
                          );
                        } else {
                          return <></>;
                        }
                      }
                    })}

                  {/* powerBi v1 */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "POWERBI" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="powerBi v1" placement="right" arrow>
                            <Link
                              to={`/main/powerBi`}
                              onClick={() => {
                                props.setsidebarVal("powerBi");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "powerBi"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <SiPowerbi color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Supervisor Contact */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SALES_SERVICE_GALADHARI" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Contact" placement="right" arrow>
                            <Link
                              to={`/main/supervisorContact`}
                              onClick={() => {
                                props.setsidebarVal("supervisorContact");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "supervisorContact"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <IoIosContacts color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Queue-Chat */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "QUEUED_INTERACTION" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Queue Chat" placement="right" arrow>
                            <Link
                              to={`/main/Queue-Chat`}
                              onClick={() => {
                                props.setsidebarVal("Queue-Chat");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Queue-Chat"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <StyledBadge
                                  badgeContent={queueCount}
                                  sx={{
                                    ".MuiBadge-badge": {
                                      background: "#DB3240",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <LuUsers color="white" size={17} />
                                </StyledBadge>
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* Reports */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "REPORTS" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Reports" placement="right" arrow>
                            <Link
                              to={`/main/reports`}
                              onClick={() => {
                                props.setsidebarVal("reports");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "reports"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbReportSearch color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* salesreport GALADHARI*/}
                  {permission.map((module) => {
                    if (module.moduleName === "REPORT") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SALES_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Sales Reports"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/salesreport`}
                              onClick={() => {
                                props.setsidebarVal("salesreport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "salesreport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <ChartLineUp color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* servicereport GALADHARI*/}
                  {permission.map((module) => {
                    if (module.moduleName === "REPORT") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "SERVICE_REPORT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Service Reports"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/servicereport`}
                              onClick={() => {
                                props.setsidebarVal("servicereport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "servicereport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <MdOutlineHomeRepairService
                                  color="white"
                                  size={17}
                                />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* customerdetails AGMC */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CUSTOMERDETAILS_AGMC" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Customer Details"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/customerdetails`}
                              onClick={() => {
                                props.setsidebarVal("customerdetails");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "customerdetails"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbUsersGroup color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* makecall */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Abandoned Calls"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/makecall`}
                              onClick={() => {
                                props.setsidebarVal("makecall");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "makecall"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <HiOutlinePhoneMissedCall
                                  color="white"
                                  size={17}
                                />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {/* WhatsappoutboundReport */}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "" && item.read && item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Whatsapp Outbound Report"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/WhatsappoutboundReport`}
                              onClick={() => {
                                props.setsidebarVal("WhatsappoutboundReport");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "WhatsappoutboundReport"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <FaWhatsapp color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CALL_RECORDING" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Call Queries" placement="right" arrow>
                            <Link
                              to={`/main/callqueries`}
                              onClick={() => {
                                props.setsidebarVal("Callqueries");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "Callqueries"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <TbHeadset color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "SIDEBAR") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "UC_RECORDING" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="CallRecording"
                            placement="right"
                            arrow
                          >
                            <Link
                              to={`/main/UCCallRecording`}
                              onClick={() => {
                                props.setsidebarVal("UCCallRecording");
                                props.setValue(0);
                              }}
                            >
                              <StyledBox
                                sx={{
                                  background:
                                    props.sidebarVal == "UCCallRecording"
                                      ? "#347EDD"
                                      : "",
                                }}
                              >
                                <IoHeadsetOutline color="white" size={17} />
                              </StyledBox>
                            </Link>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                </>
              )}
            </Stack>
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default connect(mapStateToProps, {
  clearnotify,
  setsidebarVal,
  setExternalChatData,
  setValue,
})(Sidebar);
